var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.contactNumber)?_c('p',{staticClass:"notification_label"},[_vm._v("You received a call on a lead from "+_vm._s(_vm.contactNumber))]):_c('p',{staticClass:"notification_label"},[_vm._v("You received a call on a lead")]),_vm._v(" "),_c('button-link',{on:{"click":_vm.goToLead}},[_vm._v(_vm._s(_vm.notification.data.record_address))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }